<template>
  <!-- 财务报告 -->
  <div>
    <a-card>
      <div class="text-right">
        <batch-upload-modal
          ref="batchUploadModal"
          btnText="上传报表"
          icon="upload"
          modal-title="上传报表"
          @ok="handleUploadModalOk"
          @download="_downloadTemp"
        />
        <a-button
          class="button-gap"
          :disabled="!tableData.length"
          @click="_export"
        >
          批量导出
        </a-button>
        <a-button
          class="button-gap"
          :disabled="!tableData.length"
          @click="toView()"
        >
          对比查看
        </a-button>
      </div>

      <a-form layout="inline" :form="form" class="card">
        <a-form-item label="财报类型">
          <a-select
            style="width: 200px"
            v-decorator="['type']"
            placeholder="请选择"
            allowClear
          >
            <a-select-option
              v-for="item in TYPE_LIST"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="财报时间">
          <a-form-item>
            <a-date-picker
              v-decorator="['yearStart']"
              mode="year"
              format="YYYY"
              placeholder="请选择"
              :open="startOpen"
              @openChange="status => handleOpenChange(status, 'startOpen')"
              @panelChange="
                value => handlePanelChange(value, 'yearStart', 'startOpen')
              "
            />
          </a-form-item>
          <span
            style="display: inline-block; width: 24px; lineHeight: 32px; textAlign: center; margin-left: -16px;"
          >
            -
          </span>
          <a-form-item>
            <a-date-picker
              v-decorator="['yearEnd']"
              mode="year"
              format="YYYY"
              placeholder="请选择"
              :open="endOpen"
              @openChange="status => handleOpenChange(status, 'endOpen')"
              @panelChange="
                value => handlePanelChange(value, 'yearEnd', 'endOpen')
              "
            />
          </a-form-item>
        </a-form-item> -->
        <a-form-item>
          <a-button @click="handleSearch" type="primary">查 询</a-button>
        </a-form-item>
      </a-form>

      <div class="card">
        <a-table
          row-key="id"
          :loading="loading"
          :row-selection="rowSelection"
          :columns="tableColumns"
          :data-source="tableData"
          :pagination="pageData"
          @change="handleClickPage"
        >
          <template slot="action" slot-scope="text, record">
            <a-button @click="toView(record)" type="link">查看</a-button>
          </template>
        </a-table>
      </div>
    </a-card>
    <finance-table-modal
      :visible="financeTableVisible"
      :data-source="financeTableData"
      :selectedRows="selectedRows"
      @close="handleClose"
    />
    <a-modal
      v-model="unusual"
      :title="unusualTitle"
      :footer="null"
      :width="width"
    >
      <card-view
        :column="column"
        :source-data="unusualDate"
        :schema="BATCH_UNUSUAL"
      ></card-view>
      <div v-if="dynamicDate != null">
        <div style="border-top: 1px dashed #999"></div>
        <div style="height: 35px; color: black; font-size: 16px; margin-top: 15px">动态列数据：</div>
        <template v-for="(item,index) in dynamicDate">
          <tr v-if="index%2===0" :key="index" style="height: 37px; color: black">
            <td style="width: 376px">
              <span>{{item.targetName}}：{{ item.targetChooseValue}}</span>
            </td>
            <td v-if="index+1<dynamicDate.length">
              <span>{{ dynamicDate[index+1].targetName }}：{{ dynamicDate[index+1].targetChooseValue}}</span>
            </td>
          </tr>
        </template>
      </div>
    </a-modal>
  </div>
</template>

<script>
import BatchUploadModal from 'components/BatchUploadModal.vue'
import FinanceTableModal from './components/FinanceTableModal.vue'
import mixin from './mixin'
import {
  getTableData,
  exportFile,
  downloadTemp,
  uploadFile,
  getFinanceView,
  selectUnusual,
  selectDynamic,
} from './api'
import { TYPE_LIST, BATCH_UNUSUAL } from './const'
import moment from 'moment'
import { CardView } from 'lxfintech-fe'

export default {
  name: 'financial-report',
  mixins: [mixin],
  data() {
    return {
      loading: false,
      selectedRows: [],
      financeTableData: [],
      financeTableVisible: false,
      TYPE_LIST,
      BATCH_UNUSUAL,
      column: 2,
      form: this.$form.createForm(this),
      startOpen: false,
      endOpen: false,
      unusual: false,
      unusualDate: {
        record: {},
      },
      dynamicDate: {},
      unusualTitle: '评分卡财报数据详情',
      width: 800,
    }
  },
  created() {
    this._getTableData()
  },
  computed: {
    customerCode() {
      return this.$store.getters['app/company'].code
    },
    rowSelection() {
      return {
        hideDefaultSelections: true,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
      }
    },
  },
  methods: {
    getParams() {
      const pageData = this.pageData
      const searchForm = this.searchForm
      const params = {
        customerCode: this.customerCode,
        ...this.searchForm,
        type: searchForm.type,
        yearStart: searchForm.yearStart
          ? moment(searchForm.yearStart).format('YYYY')
          : '',
        yearEnd: searchForm.yearEnd
          ? moment(searchForm.yearEnd).format('YYYY')
          : '',
        current: pageData.current,
        size: pageData.pageSize,
      }
      return params
    },
    async _getTableData() {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        const params = this.getParams()
        const {
          data: { total, records },
        } = await getTableData(params)
        this.tableData = records
        this.pageData.total = total
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async handleUploadModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          await uploadFile({ file: fileList, companyCode: this.customerCode })
          this.handleUploadModalCancel()
          this._getTableData()
        } catch (error) {
          console.error(error)
        }
      }
    },
    handleUploadModalCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },
    _downloadTemp() {
      downloadTemp()
    },
    async _export() {
      const params = {
        ...this.searchForm,
        customerCode: this.customerCode,
        ids: this.selectedRows && this.selectedRows.map(item => item.id),
      }
      exportFile(params)
    },
    async toView(item) {
      if (item.type == '批量') {
        this.handleSelectUnusual(item.id)
        const { data } = await selectDynamic(item.id)
        this.dynamicDate = data
        this.unusual = true
      } else {
        if (item) {
          this._getFinanceView([item.id])
          this.selectedRows = [item]
          // this.financeTimes = [item.reportTime]
          return
        }
        const ids = this.selectedRows.map(item => item.id)
        const length = ids.length
        if (!length) {
          this.$message.warning('请勾选需要查看的财报')
          return
        }
        if (length < 2) {
          this.$message.warning('最少勾选2条财报')
          return
        }
        if (length > 3) {
          this.$message.warning('最多勾选3条财报')
          return
        }
        this._getFinanceView(ids)
      }
    },

    async _getFinanceView(ids) {
      try {
        const { data } = await getFinanceView({
          ids,
          customerCode: this.customerCode,
        })
        this.financeTableData = data
        this.financeTableVisible = true
      } catch (error) {
        console.error(error)
      }
    },
    handleClose() {
      this.financeTableVisible = false
    },
    handleOpenChange(status, key) {
      this[key] = status
    },
    handlePanelChange(value, key, openKey) {
      this.form.setFieldsValue({ [key]: value })
      this[openKey] = false
    },

    async handleSelectUnusual(id) {
      try {
        const { data } = await selectUnusual(id)
        this.unusualDate = data
      } catch (error) {
        console.error(error)
      }
    },
  },

  components: {
    BatchUploadModal,
    FinanceTableModal,
    CardView,
  },
}
</script>

<style lang="less" scoped>
.button-gap {
  margin-left: 10px;
}
</style>
